module.exports = __webpack_public_path__ + "tinymce.b84225c5a236c3f6cc1a.svg";


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/assets/tinymce/skins/lightgray/fonts/tinymce.svg
// module id = ../../../../../src/assets/tinymce/skins/lightgray/fonts/tinymce.svg
// module chunks = styles